import { buildSpectateUrl } from '~spa/Utils/Spectate';
import { post } from '~shared/utils/http';

export const getWidgetLoaderScript = (fixtureId) => {
    const url = buildSpectateUrl('/bg_streaming/widgetLoader');

    return post(url, { fixtureId })
            .then(response => {
                if (!response.ok) {
                    throw new Error(response.statusText);
                }

                return response.text();
            });
};
